import {useEffect, useRef} from 'react';

interface Props {
    showMore: boolean;
    loadingMore: boolean;
    loading: boolean;
    onLoadMore: () => void;
}

export default function InfiniteScrollSentinel({showMore, loadingMore, loading, onLoadMore}: Props) {
    const sentinelRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!sentinelRef.current) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && showMore && !loadingMore && !loading) {
                    onLoadMore();
                }
            },
            {rootMargin: '200px'}
        );
        observer.observe(sentinelRef.current);
        return () => observer.disconnect();
    }, [showMore, loadingMore, loading]);

    return (
        <div ref={sentinelRef} style={{padding: '16px', textAlign: 'center'}}>
            {loadingMore && <p>로딩 중...</p>}
        </div>
    );
}
